<script setup lang="ts">
import { MoreVertical } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'
import { DropdownMenuTrigger } from '../../ui/dropdown-menu'
import { Button, type ButtonVariants } from '../../ui/button'
import ElementalMenu from '@/components/ElemetalMenu/index.vue'
import type { Elemental } from '~~/src/types/elemental'
import { cn } from '~~/src/utils'

defineProps<
{
  elemental: Elemental
  hideCopyLinkAction?: boolean
  parentListId?: string
  elementalsType?: ElementalTypeEnum
  btnClass?: HTMLAttributes['class']
  btnVariant?: ButtonVariants['variant']
}>()

// emit event to parent
const emit = defineEmits<{
  (e: 'openMenu'): void
}>()

defineOptions({
  name: 'ElementalOptions',
})
</script>

<template>
  <ElementalMenu
    :elemental="elemental"
    :show-open-action="false"
    :hide-copy-link-action="hideCopyLinkAction"
    :parent-list-id="parentListId"
    :elementals-type="elementalsType"
    @update:open="() => emit('openMenu')"
  >
    <template #trigger>
      <DropdownMenuTrigger
        :as="Button"
        :variant="btnVariant ?? 'snack-ghost'"
        size="icon"
        type="button"
        :class="cn(btnVariant ? 'text-soft-black' : 'rounded-full text-soft-black', btnClass)"
        @click.prevent.stop
      >
        <MoreVertical />
      </DropdownMenuTrigger>
    </template>
  </ElementalMenu>
</template>
